export default class myClass {
	constructor($scope,
		$routeParams,
		$location,
		method,
		preincidenciasService,
		PreincidenciaToIncidencia,
		$uibModal,
		toastr,
		inventarioService,
		info,
		estadosService,
		filtros
	) {
		this.scope = $scope;
		this.uibModal = $uibModal;
		this.toastr = toastr;
		this.location = $location;
		this.scope.info = info;
		//this.scope.readOnly = !info.permisos.pi.w;

		var self = this;
		this.scope.$watch("info.get('permisos')", function (newVal) {
			if (angular.isDefined(newVal) && angular.isDefined(newVal.pi)) {
				self.scope.readOnly = !newVal.pi.w;
			}
		});
		this.scope.handleDisplayFilters = this.handleDisplayFilters.bind(this);
		this.scope.displayFilters = false;

		// if (self.scope.readOnly == undefined) {
		// 	self.scope.readOnly = !info.get('permisos').pi.w;
		// };

		switch (method) {
			case 'list':

				this.listAll(preincidenciasService, estadosService, filtros, info);
				break;
			case 'view':
				//this.location = $location;
				this.view($routeParams, preincidenciasService, inventarioService);
				this.PreincidenciaToIncidencia = PreincidenciaToIncidencia;
				this.scope.crearIncidencia = this.crearIncidencia.bind(this);
				break;
			default:
				console.log('default');
				break;
		}
	}

	listAll(preincidenciasService, estadosService, filtros, info) {

		let self = this.scope;
		this.scope.filtros = filtros.preincidencia;
		this.scope.userProyects = info.get('proyectos');		
		self.aux = {};
		//let desde = new Date();
		//desde.setDate(desde.getDate()-30);
		//self.aux.desde = moment(desde);
		this.scope.filtro = {
			"estado.index": 1//,
			//fecha_incidencia: {"$gte": new Date(desde.getTime()) }
		};

		let query = JSON.stringify(this.scope.filtro);
		estadosService.getAll({ grupo: 'preincidencia' })
			.then((resp) => {
				this.scope.estados = resp.data.message;;
				this.scope.estados.forEach(estado => {
					if (estado.index === 1) {
						self.filtros.estado = estado;
					}
				});
			});

		preincidenciasService.getAll(query)
			.then((resp, err) => {
				if (err) {
					console.log('error');
				} else {
					this.scope.preincidencias = resp.data.message;

				}
			}).catch((data) => {
				console.log(data);
			});

		this.scope.showPreincidencia = (incidencia) => {
			this.location.path('/preincidencia/' + incidencia._id);
		};

		this.scope.filtrar = () => {
			let query = null;

			// El filtro de estado nunca es nulo.
			// Se evalua si ambos filtros de fecha estan llenos

			if (self.filtros.desdeM && self.filtros.hastaM) {

				let timezone = self.filtros.desdeM._d.getTimezoneOffset();

				query = {
					"estado.index": self.filtros.estado.index,
					fecha_incidencia: {
						"$gte": self.filtros.desdeM._d.getTime() - (timezone * 60 * 1000),
						"$lt": self.filtros.hastaM._d.getTime() - (timezone * 60 * 1000)
					}
				}

			} 
			
			// Se evalua si solo el filtro "desde" esta lleno

			else if (self.filtros.desdeM){

				let timezone = self.filtros.desdeM._d.getTimezoneOffset();

				query = {
					"estado.index": self.filtros.estado.index,
					fecha_incidencia: {
						"$gte": self.filtros.desdeM._d.getTime() - (timezone * 60 * 1000)
					}
				}
			} 
			
			// Se evalua si solo el filtro "hasta" esta lleno
			
			else if (self.filtros.hastaM) {

				let timezone = self.filtros.hastaM._d.getTimezoneOffset();

				query = {
					"estado.index": self.filtros.estado.index,
					fecha_incidencia: {
						"$lt": self.filtros.hastaM._d.getTime() - (timezone * 60 * 1000)
					}
				}
			} 
			
			// Si ninguno esta lleno, solo se coloca el estado en el query

			else{
				query = {
					"estado.index": self.filtros.estado.index
				}
			}

			query = JSON.stringify(query);

			preincidenciasService.getAll(query)
				.then((resp, err) => {
					if (err) {
						console.log('error');
					} else {
						this.scope.preincidencias = resp.data.message;
					}
				}).catch((data) => {
					console.log(data);
				});
		}
	}

	view($routeParams, preincidenciasService, inventarioService) {
		let id = $routeParams.id;
		this.scope.aux = {};

		preincidenciasService.getById({ id: id }).then((resp, err) => {

			this.scope.preincidencia = resp.data.message;
			if (this.scope.preincidencia.fecha_incidencia) {
				this.scope.aux.fecha_incidencia = moment(new Date(this.scope.preincidencia.fecha_incidencia));
				this.scope.aux.fecha_incidencia = this.scope.aux.fecha_incidencia.format('DD/MM/YYYY HH:mm');
			}

			if (this.scope.preincidencia.fecha_termino) {
				//this.scope.aux.fecha_termino = moment(new Date(this.scope.preincidencia.fecha_termino));
				this.scope.aux.fecha_termino = this.scope.preincidencia.fecha_termino;
			}

			if (this.scope.preincidencia.fecha_envio) {
				this.scope.aux.fecha_envio = moment(new Date(this.scope.preincidencia.fecha_envio));
				this.scope.aux.fecha_envio = this.scope.aux.fecha_envio.format('DD/MM/YYYY HH:mm');
			}

			if (this.scope.preincidencia.estado) {
				this.scope.aux.estado_alarma = this.scope.preincidencia.estado.nombre;
			}

			let filter_eq = {
				id_dinac: this.scope.preincidencia.equipo
			}

			inventarioService.getAll(filter_eq)
				.then((resp) => {
					if (resp.data.message.length == 1) {
						let eq = resp.data.message[0]
						this.scope.equipo = {
							n_serie: eq.numero_serie,
							n_producto: eq.numero_equipo,
							tipo_equipo: eq.tipo_equipo.nombre,
							revision: eq.revision,
							fecha_incidencia_anterior: '',
							fecha_instalacion: eq.fecha_instalacion
						};
					} else {
						console.log('no existe equipo');
					}
				});
		});

		this.scope.modificar = (objeto) => {
			let templateModal = `
				<!-- Modal content-->
				<div class="modal-content">
					<div class="modal-header">
						<h4 class="modal-title text-center"><strong> Confirmar anulación preincidencia</strong></h4>
					</div>
					<div class="modal-body">
						<textarea ng-model="mv.texto" class="form-control" style="border: 1px solid black;"></textarea>
				    </div>
				    <div class="modal-footer">
						<div class="btn btn-default pull-left" ng-click="mv.cerrar()">Cancelar</div>
						<div class="btn btn-success pull-right" ng-click="mv.enviar()">Anular</div>
				    </div>
				</div>
			`;
			var self = this;
			var modalInstance = this.uibModal.open({
				animation: true,
				ariaLabelledBy: 'modal-title',
				ariaDescribedBy: 'modal-body',
				template: templateModal,
				controller: function () {
					this.enviar = function () {
						objeto.comentario = this.texto;
						if (typeof this.texto === 'undefined' || this.texto.trim() == '') {
							self.toastr.error('Debe escribir un comentario!', 'Error!', {
								timeOut: 2000,
								closeButton: true
							});
							return;
						}
						let obj_mod = {
							_id: objeto._id,
							index: 3,
							texto: this.texto
						};

						preincidenciasService.modificar(obj_mod)
							.then((resp) => {
								modalInstance.close();
								self.toastr.success('Preincidencia anulada correctamente!', 'Success!', {
									timeOut: 2000,
									closeButton: true
								});
								self.location.url('/preincidencia');

							}).catch((err) => {
								console.log(err);
								modalInstance.close();
							});
					}
					this.cerrar = function () {
						modalInstance.close();
					};
				},
				controllerAs: 'mv',
				size: 'md'
			});

		};

	}

	crearIncidencia(data) {
		this.PreincidenciaToIncidencia.setPreincidencia(data);
		this.location.url('incidencia/new');
	}

	handleDisplayFilters() {
		this.scope.displayFilters = !this.scope.displayFilters;
	}
}



// WEBPACK FOOTER //
// ./app/js/controllers/preincidencias/preincidencias.js